<template>
    <div
        class="v-uploader-dnd"
        :class="{ 'is-dragover': isDragover, 'is-disabled': disabled }"
        @dragover.prevent="handleDragover"
        @dragleave.prevent="isDragover = false"
        @drop.prevent="handleDrop"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'VUploaderDndArea',
    props: {
        disabled: Boolean
    },
    data() {
        return {
            isDragover: false
        };
    },
    methods: {
        handleDragover(evt) {
            if (this.disabled) {
                evt.preventDefault();
                return;
            }

            this.isDragover = true;
        },
        handleDrop(evt) {
            if (this.disabled) {
                evt.preventDefault();
                return;
            }

            this.isDragover = false;
            const { files } = evt.dataTransfer;
            this.$emit('change', files);
        }
    }
};
</script>
